// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';

// Video files for desktop, GIFs for mobile
import desktopVideo from './img/ai2html-graphic-desktop.mp4';
import mobile320Gif from './img/ai2html-graphic-mobile320.gif';
import mobile375Gif from './img/ai2html-graphic-mobile375.gif';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  // Swap JPG images with GIF/MP4 versions after page load
  const desktopImg = document.getElementById('g-ai2html-graphic-desktop-img');
  const mobile320Img = document.getElementById('g-ai2html-graphic-mobile320-img');
  const mobile375Img = document.getElementById('g-ai2html-graphic-mobile375-img');

  // Helper to create video element with Safari-safe autoplay
  const createAutoplayVideo = (id, className, src) => {
    const video = document.createElement('video');
    video.id = id;
    video.className = className;
    // Set muted BEFORE src for Safari
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', ''); // Legacy Safari
    video.loop = true;
    video.setAttribute('loop', '');
    video.autoplay = true;
    video.setAttribute('autoplay', '');
    // Set src after muted
    video.src = src;
    return video;
  };

  // Desktop: use video, Mobile: use GIFs
  if (desktopImg) {
    const video = createAutoplayVideo(
      'g-ai2html-graphic-desktop-img',
      desktopImg.className,
      desktopVideo,
    );
    desktopImg.parentNode.replaceChild(video, desktopImg);
  }
  // Mobile: swap to GIF (more reliable than video on mobile Safari)
  if (mobile320Img) {
    mobile320Img.src = mobile320Gif;
  }
  if (mobile375Img) {
    mobile375Img.src = mobile375Gif;
  }

  // Adjust mobile320 .g-text-no-shadow elements only if iframe width < 300px
  const mobile320Artboard = document.getElementById('g-ai2html-graphic-mobile320');
  if (mobile320Artboard && !mobile320Artboard.dataset.adjusted && window.innerWidth < 300) {
    // Mark as adjusted to prevent re-applying on hot reload
    mobile320Artboard.dataset.adjusted = 'true';

    const noShadowDivs = mobile320Artboard.querySelectorAll('.g-text-no-shadow');
    noShadowDivs.forEach((div) => {
      // Adjust top value by subtracting 0.1175
      const currentTop = parseFloat(div.style.top);
      if (!isNaN(currentTop)) {
        div.style.top = `${currentTop - 0.1175}%`;
      }
      // Set font-size to 10px for all p tags inside
      const pTags = div.querySelectorAll('p');
      pTags.forEach((p) => {
        p.style.fontSize = '10px';
      });
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}
